import React, { useEffect, useState, useRef } from 'react';
import Popup from 'components/popup/popup';
import AddInputForm from '../../Global/AddInputForm';
import { generateRandomId, toHalfWidthUnicode } from 'utility/general';
import { isArray } from 'lodash';
import api from 'api/call';
const PopupInput = (props) => {
    const {
        selectedRow,
        editRow,
        tableList,
        setOpenPopup,
        onSubmit = () => null,
        defaultFormList,
        height = '50%',
        width = '60%',
        isShow = true,
        title,
        alignItems,
        contentElement,
        returnOriginalData,
        isUpload,
        ...rest
    } = props;

    const [formList, setFormList] = useState(defaultFormList);
    const [loading, setLoading] = useState(false);

    const [forceErrorDisplay, setForceErrorDisplay] = useState(false);
    const formValid = useRef({});

    useEffect(() => {
        setFormList(selectedRow ? initDefaultFormList() : defaultFormList);
        initFormValid();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedRow]);

    const initFormValid = () => {
        for (let i in defaultFormList) {
            if (defaultFormList[i].validators?.length) {
                // fillter out display item
                formValid.current[i] = false;
            }
        }
    };

    const initDefaultFormList = () => {
        let list = { ...defaultFormList };
        for (let i in defaultFormList) {
            list[i] = { ...defaultFormList[i], value: selectedRow[i] };
        }
        return list;
    };


    const onRemove = (index, item) => {
        const { name } = item;
        let list = formList[name].value;
        if (!isArray(list)) {
            list = [list];
        }
        list.splice(index, 1);

        setFormList({
            ...formList,
            [name]: {
                ...formList[name],
                value: list,
            },
        });
    };

    const getFormData = () => {
        /** 'temp_' use for application formDetails  */
        let list = {
            id: selectedRow
                ? selectedRow.id
                : tableList.length
                ? 'temp_' + (Number(tableList[tableList.length - 1].id) + 1).toString() + generateRandomId()
                : 'temp_0' + generateRandomId(),
        };
        for (let i in formList) {
            list[i] = formList[i].value;
        }
        const data = returnOriginalData ? {  ...selectedRow, ...list } : list;
        return data;
    };

    const checkFormValid = () => {
        let valid = true;
        for (let i in formValid.current) {
            if (!formValid.current[i]) {
                valid = false;
                break;
            }
        }
        return valid;
    };

    const handleSubmit = () => {
        if(loading) return
        setForceErrorDisplay(true);
        const valid = checkFormValid();
        console.log('is popup form valid:', valid);
        if (valid) {
            setOpenPopup(false);
            const data = getFormData();
            selectedRow ? editRow(data) : onSubmit(data);
        }
    };

    const handlePopupCancelClick = () => {
        if(loading) return
        setOpenPopup(false);
    };

    const handleFormData = (e, type) => {
        const { name, value } = e.target;
        if (type === 'uploadFile') {
            fileOnChange(e);
        } else {
            setFormList({
                ...formList,
                [name]: {
                    ...formList[name],
                    value: value,
                },
            });
        }
    };

    const fileOnChange = async(e) => {
        const { name, list } = e.target;
        const copyFormList = { ...formList };
        if(isUpload){
            try {
                let formData = new FormData();
                list.forEach((item) => {

                    let file = item;

                    try {
                        // convert the file name to all half width unicode for fix of code scan issue 
                        file = new File([item], toHalfWidthUnicode(item.name), {
                            type: item.type,
                        });
                    } catch (error) {
                        console.log('%c 121359 PopupInput.jsx error', 'background: green', error)
                    }

                    formData.append('file', file);
                });
                setLoading(true)
                const res = await api.file.uploadDocument(formData);
                setLoading(false)
                let result = res.data.result.result
                result.forEach(item=>{
                    item.name = item.fileName;
                    const index = list.findIndex(i => i.name === item.fileName);
                    if (index !== -1) {
                        item.tempFile = list[index];
                    };
                });
                copyFormList[name].value = copyFormList[name].value.concat(result);
                setFormList(copyFormList);
            } catch (error) {
                setLoading(false)
            }
        }else{
            if (list.length) {
                copyFormList[name].value = copyFormList[name].value.concat(list);
                setFormList(copyFormList);
            }
        }
    };

    return (
        <Popup
            height={height}
            width={width}
            title={title ?? ''}
            open={isShow}
            footerActions={[
                { label: 'Cancel', clicked: handlePopupCancelClick, color: 'default' },
                { label: selectedRow ? 'Confirm' : 'Add', clicked: handleSubmit },
            ]}
            closePopup={handlePopupCancelClick}
        >
            {contentElement ? (
                contentElement
            ) : (
                <AddInputForm
                    loading={loading}
                    isLoading={loading}
                    forceErrorDisplay={forceErrorDisplay}
                    formValid={formValid}
                    alignItems={alignItems}
                    formList={formList}
                    handleFormData={handleFormData}
                    onRemove={onRemove}
                    {...rest}
                />
            )}
        </Popup>
    );
};

export default PopupInput;
